<template>
  <div>
    <app-heading
      :text="'NBN Quote Management'"
      :heading="'main'"
    ></app-heading>
    <v-row class="mb-4">
      <v-col
        cols="12"
        md="8"
        lg="9"
        class="pt-0 pb-0"
        :class="$vuetify.breakpoint.xs ? 'pr-3' : 'pr-0'"
      >
        <v-btn
          class="primary"
          @click="addQuote({})"
          :style="$vuetify.breakpoint.xs ? 'width: 100%' : ''"
          :class="$vuetify.breakpoint.xs ? 'mt-4' : 'mt-6'"
        >Create a Quote</v-btn
        >
      </v-col>
    </v-row>
    <v-divider class="mt-6 mb-4"></v-divider>

    <v-row class="mb-4">
      <v-col cols="12" sm="9" md="9" class="py-0">
        <v-row>
          <v-col cols="12" sm="3" md="2" class="py-0">
            <v-checkbox
              label="Completed"
              v-model="filterCompleted"
              class="custom-width"
              :class="$vuetify.breakpoint.xs ? 'mt-0' : ''"
            ></v-checkbox>
          </v-col>

          <v-col cols="12" sm="3" md="2" class="py-0">
            <v-checkbox
              label="Cancelled"
              v-model="filterCancelled"
              class="custom-width"
              :class="$vuetify.breakpoint.xs ? 'mt-0' : ''"
            ></v-checkbox>
          </v-col>

          <v-col cols="12" sm="3" md="2" class="py-0">
            <v-checkbox
              label="Rejected"
              v-model="filterRejected"
              class="custom-width"
              :class="$vuetify.breakpoint.xs ? 'mt-0' : ''"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" sm="3" :class="$vuetify.breakpoint.xs ? 'pt-0' : ''">
        <app-search @search="onGridSearch"></app-search>
      </v-col>
    </v-row>

    <ag-grid-vue
      class="ag-theme-alpine"
      style="height: 60vh"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="filteredItems"
      :gridOptions="gridOptions"
      @grid-ready="onGridReady"
      @cellClicked="onRowClicked"
      rowSelection="single"
    ></ag-grid-vue>
    <add-quote
      ref="addQuote"
      :showAddQuote="showAddQuote"
      @closeQuery="closeQuoteDialog()"
    >
    </add-quote>

    <edit-quote
      ref="editQuote"
      :showEditQuote="showEditQuote"
      :quoteRecord="quoteData"
      @closeQuery="closeQuoteDialog()"
    ></edit-quote>
  </div>
</template>

<script>
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";
import { formatDateTime} from "@/plugins/global-functions";
export default {
  name: "QuoteManagement",
  components: { AgGridVue },
  data: () => ({
    showAddQuote:false,
    showEditQuote:false,
    filterCompleted: false,
    filterCancelled: false,
    filterRejected: false,
    isEditing: false,
    quoteData: {},
    statusFilter: -1,
    pageSize: 50,
    keyword: null,
    items: [],
    defaultColDef: {
      sortable: true,
      filter: true,
      resizeable: true,
    },
    gridOptions: {},
    columnDefs: [
      {
        headerName: "Id",
        field: "id",
      },
      {
        headerName: "QuoteId",
        field: "quoteId",
      },
      {
        headerName: "LocationId",
        field: "locationId",
      },
      {
        headerName: "Status",
        field: "status",
      },
      {
        headerName: "QuoteType",
        field: "quoteType",
      },
      {
        headerName: "ReferenceId",
        field: "referenceId",
      },
      {
        headerName: "CreatedTime",
        field: "created",
        cellRenderer: function (data) {
          return formatDateTime(data.value, true);
        },
      },
      {
        headerName: "UpdatedTime",
        field: "updated",
        cellRenderer: function (data) {
          return formatDateTime(data.value, true);
        },
      }
    ],
  }),
  computed: {
    filteredItems: function () {
      let vm = this;
      // let items = vm.appointments;

      // if (!vm.filterCompleted) items = items.filter((x) => x.status != 4);
      //
      // if (!vm.filterCancelled) items = items.filter((x) => x.status != 0);
      //
      // if (!vm.filterRejected) items = items.filter((x) => x.status != 1);

      return vm.items;
    },
  },
  methods:{
    addQuote(){
      let vm = this;
      vm.$refs.addQuote.showAddQuote = true;
    },
    editQuote(){
      let vm = this;
      vm.$refs.editQuote.showEditQuote = true;
    },
    closeQuoteDialog(){
      let vm = this;
      vm.$refs.addQuote.showAddQuote = false;
      vm.showAddQuote = false;

      vm.$refs.editQuote.showEditQuote = false;
      vm.showEditQuote = false;

      vm.getQuotesData();
    },
    onGridSearch(keyword) {
      let vm = this;

      if (vm.statusFilter === null) vm.statusFilter = -1;

      vm.keyword = keyword;

      var search = {
        keyword: vm.keyword,
        statusFilter: parseInt(vm.statusFilter),
        pageSize: parseInt(vm.pageSize),
      };

      clearTimeout(vm._timerId);

      vm._timerId = setTimeout(() => {
        vm.getQuotesAsync(search)
          .then((data) => {
            vm.items = data.data;
            vm.gridApi.sizeColumnsToFit();
          })
          .catch(() => {});
      }, 500);
    },
    onGridReady(args) {
      let vm = this;
      vm.gridApi = args.api;
    },
    onRowClicked(args) {
      let vm = this;
      var payload = {quoteID:args.data.quoteId};
      vm.getQuoteAsync(payload)
        .then((data) => {
          vm.$refs.editQuote.showEditQuote = true;
          vm.showEditQuote = true;
          vm.quoteData = {response:data, quoteData:args.data};
        })
        .catch(() => {});
    },
    getQuotesData(){
      let vm=this;
      var search = {
        keyword: null,
        statusFilter: -1,
        pageSize: 50
      }

      vm.getQuotesAsync(search)
        .then((data) => {
          vm.items = data.data;
          vm.gridApi.sizeColumnsToFit();
        })
        .catch(() => {});
    }
  },
  beforeMount() {
    let vm = this;
    vm.getQuotesData();
  },
  mounted() {
    let vm = this;
    vm.gridApi = vm.gridOptions.api;
    vm.gridColumnApi = vm.gridOptions.columnApi;
  },
}
</script>

<style scoped>

</style>
